import React, { useState, useContext, useMemo } from 'react'
import styled, { css } from 'styled-components'
import theme from '../constants/theme'

const InactiveProgress = styled.div`
  background: linear-gradient(90deg, #e0e0e0 50%, transparent 50%, transparent),
    linear-gradient(126deg, #ff70a6 50%, #e0e0e0 50%, #e0e0e0);
  border-radius: 50%;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  height: 200px;
  margin: 2em auto;
  position: relative;
  min-width: 200px;
  margin: 10px;
  transition: all 0.3s linear;
`

const LoadingWrapper = styled.div`
  background: white;
  background-size: 103px;
  position: relative;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${() => theme.retailer.successColor};
  width: 106px;
  height: 106px;
  border: ${() => `3px solid ${theme.retailer.icon.color}`};

  @media (max-width: 450px) {
    height: 100px;
    width: 100px;
  }

  background: ${({ background }) => background};
  border-radius: 50%;
`

const LoadingCircle = styled.div`
  width: 80px;
  height: 80px;
  background-color: ${() => theme.retailer.icon.color};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 450px) {
    height: 78px;
    width: 78px;
  }
`

const Icon = styled.img`
  max-width: 73px;
  max-height: 73px;
  width: auto;
  height: auto;
  padding: 5px;
`

const Percent = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50px;
  background: #ffffff;
  border: 2px solid #b93924;
  position: absolute;
  bottom: 8px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    display: block;
    font-size: 11px;
  }
`

export const CircularProgress = ({ progress, iconPath, name }) => {
  const getBackground = () => {
    const { successColor } = theme.retailer
    const rotate = 180 * (progress / 50) + 90
    if (progress <= 50) {
      return `linear-gradient(90deg, white 50%, transparent 50%, transparent),
    linear-gradient(${rotate}deg, ${successColor} 50%, white 50%)`
    }

    return `linear-gradient(270deg, ${successColor} 50%, transparent 50%, transparent),
    linear-gradient(${rotate}deg, ${successColor} 50%, white 50%)`
  }

  return (
    <LoadingWrapper background={getBackground()}>
      <LoadingCircle>
        <Icon src={iconPath} height={60} width={60} alt="" aria-hidden />
        <Percent>
          <span
            aria-hidden
            aria-label={`${progress}% of ${name} tutorial completed.`}
            title={`${progress}% of the course completed.`}
          >
            {progress}%
          </span>
        </Percent>
      </LoadingCircle>
    </LoadingWrapper>
  )
}
